import { ObjectValues } from 'type-alias';

export const GROUP_ROLE_EXTERNAL_TYPE = {
  User: 'User',
  Channel: 'Channel',
} as const;

export type GROUP_ROLE_EXTERNAL_TYPE_VALUES = ObjectValues<
  typeof GROUP_ROLE_EXTERNAL_TYPE
>;
